import React, { FunctionComponent } from "react";
import { Dialog } from "@plex/react-components";
import { IViewController, useViewController } from "../ViewContext";
import "./UserDefinedSchemaEditor.scss";
import { UserDefinedSchemaDetailsForm } from "./UserDefinedSchemaDetailsForm";
import { getSchema } from "../NodeTypes/DataSchemas";
import { IDocumentObjectSchema } from "../FlowDocument/FlowDocumentModel";

export interface IUserDefinedSchemaDetailsDialogState {
  show: boolean;
  schemaName: string;
  schemaInUse: boolean;
  selectedPropertyName?: string;
  loopVariable: boolean;
  loopNodeId?: string;
}

export interface IUserDefinedSchemaDialogProps {
  onClose?: () => void;
}

export const UserDefinedSchemaDetailsDialog: FunctionComponent<IUserDefinedSchemaDialogProps> = (props) => {
  const { userDefinedSchemasEditorState, userDefinedSchemaDetailsDialogState }: IViewController = useViewController();
  const onSave = (schemaId: string, schemaName: string) => {
    const schema = getSchema(schemaId) as unknown as IDocumentObjectSchema;
    if (schema) {
      schema.metadata.userDefinedSchemaName = schemaName;
    }
  };
  return (
    <Dialog
      show={userDefinedSchemaDetailsDialogState.show}
      onHide={props.onClose}
      title={userDefinedSchemaDetailsDialogState.loopVariable ? "Variables" : "User Defined Schema"}
      className="user-defined-schema-dialog"
    >
      <div style={{ height: "auto" }}>
        <UserDefinedSchemaDetailsForm schemaId={userDefinedSchemasEditorState.selectedSchemaId} onSave={onSave} />
      </div>
    </Dialog>
  );
};
